import React, { useState } from 'react'
import './LoginPage.css'
import India1 from './images/india2.png'
import India from './images/india.png'
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import firebase from "./firebase";


function LoginPage() {
    const inputs = document.querySelectorAll(".input");
	const [userName,setUserName]=useState('')
	const [pass,setPass]=useState('')
	const [error,setError]=useState('')
	const navigate= useNavigate()


function addcl(){
	let parent = this.parentNode.parentNode;
	parent.classList.add("focus");
}

function remcl(){
	let parent = this.parentNode.parentNode;
	if(this.value == ""){
		parent.classList.remove("focus");
	}
}


inputs.forEach(input => {
	input.addEventListener("focus", addcl);
	input.addEventListener("blur", remcl);
});
   
const handleValidate = ()=>{
	if(userName===''){
		setError('Please Enter UserName')
		return
	}
	if(pass===''){
		setError('Please Enter Password')
		return
	}
    console.log(userName,pass)
	firebase
           .auth()
           .signInWithEmailAndPassword(userName, pass)
           .then((userCredential) => {
             // Signed in
			 navigate('/home')
			 setError('')
             const user = userCredential.user;    
             console.log(user)
           })
           .catch((error) => {
             const errorCode = error.code;
             const errorMessage = error.message;
             console.log(errorCode);
             console.log(errorMessage);
   
             if (
               errorCode === "auth/user-not-found" ||
               errorCode === "auth/invalid-email"
             ) {
               
               setError("User Doesn't Exists")
        
               // emailRef.current.focus();
             } else {
				setError("Password Incorrect")
             }
           });



}



  return (
    <div>

<img class="wave" src="https://raw.githubusercontent.com/sefyudem/Responsive-Login-Form/master/img/wave.png" />
	<div class="container">
		<div class="img">
			<img src={India1}  />
		</div>
		<div class="login-content">
			<form>
			{ error &&
				<div className='error'>
					 <div> {error} </div>
					<div>
						<IoClose style={{cursor:"pointer"}} onClick={()=>setError('')} size={20} color='red' />
					</div>
					 </div>
}
				<img src="https://raw.githubusercontent.com/sefyudem/Responsive-Login-Form/master/img/avatar.svg" />
				<h2 class="title">5C Network</h2>
				{/* <h2 class="title">Welcome</h2> */}
           		<div class="input-div one">
           		   <div class="i">
           		   		<i class="fas fa-user"></i>
           		   </div>
           		   <div class="div">
						{/* <h5>Username</h5>   */}
           		   		<input onChange={(e)=>setUserName(e.target.value)} type="text" class="input" required placeholder='Username' />
           		   </div>
           		</div>
           		<div class="input-div pass">
           		   <div class="i"> 
           		    	<i class="fas fa-lock"></i>
           		   </div>
           		   <div class="div">
           		    	{/* <h5>Password</h5> */}
           		    	<input onChange={(e)=>setPass(e.target.value)} type="password" class="input" required placeholder='Password' />
            	   </div>
            	</div>
            	{/* <a href="#">Forgot Password?</a> */}
            	<input type="button" onClick={()=>handleValidate()}  style={{marginTop:'30px'}} class="btn" value="Login" />
            </form>
        </div>
    </div>
      
    </div>
  )
}

export default LoginPage
